<template>
  <div class="fallback-view h-full flex justify-center items-center">
    <div class="fallback-view__content flex flex-col items-center" :style="{ gap: contentGap }">
      <div
        class="fallback-view__icon-and-text flex flex-col items-center"
        :style="{ gap: iconTextGap }"
      >
        <div class="fallback-view__icon">
          <slot name="icon" />
        </div>

        <div
          class="fallback-view__text flex flex-col items-center"
          :style="{ gap: textGap }"
        >
          <slot name="content" />
        </div>
      </div>

      <div class="fallback-view__action">
        <slot name="action" />
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  contentGap: {
    type: String,
    default: '80px'
  },
  iconTextGap: {
    type: String,
    default: '50px'
  },
  textGap: {
    type: String,
    default: '32px'
  }
})
</script>
